export const getServerErrorMessage = (error: unknown): string => {
  const fallbackMessage =
    'Oops. Something went wrong. Please try again later.';

  if (typeof error === 'string' && error) {
    return error;
  }

  if (!error || typeof error !== 'object') {
    return fallbackMessage;
  }

  // check API response payload first
  const response = (
    error as { response?: { data?: unknown; status?: number } }
  ).response;
  const data = response?.data;
  if (data && typeof data === 'object') {
    const payloadData = (
      (data as { payload?: unknown }).payload ?? data
    ) as Record<string, unknown>;

    if (typeof payloadData.detail === 'string' && payloadData.detail) {
      return payloadData.detail;
    }
    if (typeof payloadData.message === 'string' && payloadData.message) {
      return payloadData.message;
    }
  }

  if (typeof response?.status === 'number' && response.status >= 500) {
    return fallbackMessage;
  }

  // fall back to .message for non-HTTP errors (e.g. network errors)
  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
};
